<template>
	<div>
		<h2 class="">{{ item.title }}</h2>
		<back></back>
		<div class="wh-block" v-if="!start && !finish">
			<instructions></instructions>
		</div>		

		<div v-if="start && !finish && params.users > 1" class="trainer">
      <div class="trainer__header">  
        <panelka class="teacher__menu"></panelka>
      </div>
      
			<div class="trainer__body trainer__body--multy">
				<game 
          :inkey="val"
          :multiplayer="true"
          v-for="(val, key) in +params.users" :key="key"
          class="columns__item"
          :style="`flex-basis: ${100 / +params.users}%`"
        ></game>
			</div>
		</div>
		<div v-else>
      <div class="trainer" v-if="start && !finish">
        <div class="trainer__header">
          <panelka class="teacher__menu"></panelka>
          <a v-if="this.user.role.code !== 'teacher'" href="#" @click.prevent="onStopTrainer">Остановить</a>
        </div>
        <div class="trainer__body">
          <game 
            ref="gameSingle" 
            :inkey="1" 
            class="columns__item single"
          ></game>
        </div>
      </div>			
		</div>
	</div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import { mental_params_mix } from "../mental/mental_params_mixin";

  export default {
    name: "start",
    data() {
      return {}

    },
    mixins: [
      mental_params_mix
    ],
    components: {
      'instructions': require('./instructions').default,
      'game': require('./game').default,
      'panelka': require('./../panelka').default
    },
    props: {},
    watch: {
      //'start': 'scroll'
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      users: {
        get() {
          return this.$store.state.train.columns_params.users
        },
        set(value) {
          this.commitVal(value, 'users');
        }
      },
      ...mapState({
        params: state => state.train.columns_params,
        item: state => state.current_trainer,
        start: state => state.train.columns_params.start,
        finish: state => state.train.columns_params.finish,
      })
    },
    methods: {
      commitVal(value, param, method = 'train/changeColumnsParams') {
        let val = {
          param_name: param,
          param_val: value
        }
        this.$store.commit(method, val);
      },
      onStopTrainer() {
        this.commitVal(false, 'start');
        if (this.$route.params.isHomework) {        
          this.$router.push({ name: 'student_homework' });
        }
      },
      scroll() {
        if (this.start) {
          UIkit.scroll('.headline2').scrollTo('.game__body');
        }
      },
      keyPress(e) {
        let app = this;
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
          let inp = $('.game_input');
          if (app.start && inp.length === 0) {
            console.log('Все отвечены');
            app.$root.$emit('fullStart');
          }
          //console.log('Нажали энтер');
        }
      }
    },
    mounted() {
      window.document.addEventListener('keypress', this.keyPress);
    },
    beforeDestroy() {
      console.log('Start Destroy');
      window.document.removeEventListener('keypress', this.keyPress, false);
    }
  }
</script>

<style lang="scss" scoped>
.trainer__body {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
}

.columns__item {
  display: flex;
  flex-direction: column;
  max-width: 400px;
  transition: none;

  &.single {
    width: 100%;
  }
  
  height: 100%;
}

.teacher__menu {
  width: 100%;
}

@media (max-width: 640px) {
  .trainer__body {
    flex-wrap: wrap;
  }
}
</style>
